import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { MessageSquare, Mail, Phone } from "lucide-react";
import { API } from "@/contexts/AuthContext";

export default function MessagesList() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/contact`);
      setMessages(data || []);
    } catch (e) {
      console.error("Failed to load messages:", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="messages-page">
      <div className="mb-8">
        <div className="text-sm uppercase tracking-wider text-[#EA823A] font-semibold mb-2">Inbox</div>
        <h1 className="font-display text-4xl text-[#1F2A2E]">Contact messages</h1>
        <p className="text-[#4A595E] mt-2">General enquiries from the public site.</p>
      </div>

      {loading ? (
        <div className="text-center py-20"><div className="w-8 h-8 border-3 border-[#E2718A] border-t-transparent rounded-full animate-spin mx-auto" /></div>
      ) : messages.length === 0 ? (
        <div className="text-center py-20 bg-white rounded-3xl border border-[#F0E5DE]">
          <MessageSquare className="w-12 h-12 mx-auto text-[#F4C3CC] mb-4" />
          <h3 className="font-display text-xl text-[#1F2A2E] mb-2">No messages yet</h3>
          <p className="text-[#6B7A80] text-sm">When someone reaches out via the Connect page, it'll appear here.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {messages.map((m) => (
            <div key={m.id} className="bg-white rounded-3xl border border-[#F0E5DE] p-6" data-testid={`message-${m.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3 mb-4">
                <div>
                  <div className="font-display text-lg text-[#1F2A2E]">{m.name}</div>
                  <div className="flex items-center gap-4 mt-1 text-sm text-[#6B7A80]">
                    <a href={`mailto:${m.email}`} className="flex items-center gap-1.5 hover:text-[#E2718A]"><Mail className="w-3.5 h-3.5" />{m.email}</a>
                    {m.phone && <a href={`tel:${m.phone}`} className="flex items-center gap-1.5 hover:text-[#E2718A]"><Phone className="w-3.5 h-3.5" />{m.phone}</a>}
                  </div>
                </div>
                <div className="text-xs text-[#6B7A80]">{new Date(m.created_at).toLocaleString("en-AU", { dateStyle: "medium", timeStyle: "short" })}</div>
              </div>
              {m.subject && <div className="text-sm font-semibold text-[#284952] mb-2">{m.subject}</div>}
              <p className="text-[#284952] leading-relaxed whitespace-pre-line">{m.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
